import React, { useEffect, useState } from 'react';
import { initGoogleAuth } from '../lib/auth.jsx';

export default function LoginPage({ onLogin }) {
  const [error, setError] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => {
      initGoogleAuth(
        (user) => onLogin(user),
        (err) => setError(err)
      );
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-8">
        <h1 className="text-3xl font-bold text-center mb-2">QA Scorecard</h1>
        <p className="text-gray-600 text-center mb-8">Sabrent Support Quality Assessment</p>
        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-6">{error}</div>
        )}
        <div className="flex justify-center">
          <div id="google-signin-btn"></div>
        </div>
      </div>
    </div>
  );
}